<style type="text/css">
  .section-settings-container {
    position: relative;
    padding: 50px 0;
  }
  /*
  #section_npv .section-settings-container,
  #section_wc .section-settings-container {
    @media (min-width: 800px) {
      max-width: 500px;
    }
  }
  */

  .section-container {
    background-color: #fff;
    box-shadow: -1px 2px 8px 0 rgba(0, 0, 0, .08);
    position: relative;
  }

  .section-settings-container__form {
    flex: 1 1 0;
    background-color: #F5F5F5;
    padding: 10px;
    @media (min-width: 800px) {
      /*padding: 20px;*/
    }
    .section-title {
      font-size: 20px;
      padding: 0;
      margin-bottom: 10px;
    }
    .v-card__text {
      padding: 0;
    }
  }

  .section-settings-container .v-sheet {
    z-index: 1;
    display: flex;
    background-color: #fff;
    border: 1px solid #ddd;
    flex: 1 1 0;
    max-width: 500px;
  }

  @media only screen and (max-width: 600px) {
    .section-settings-container .v-sheet {
      flex-direction: column;
    }
  }
/*
  .isEditingSettings {
    display: flex;
    width: 80%;
    margin: 40px auto 5px;
    justify-content: center;
  }
*/
  .section-settings-container-wrapper {
    position: relative;
    background-color: #fff;
  }

  #section_general .section-settings-container-wrapper {
    border-top: none;
    border-bottom: none;
  }

  #section_general .table-container__center {
    background-color: #fff;
  }

  .table-container {
    background-color: #fff;
  }

  .table-container__center {
    background: #fff;
    position: relative;
    padding-left: 25px;
  }

  .input-date-picker .v-menu__content {
    max-width: inherit;
  }

</style>

<template>
  <div v-if="section.isEnabled" style="position:relative;">
    <div style="display:flex;">
      <div
        :id="section.id"
        style="overflow-x: auto; position: relative;"
      >
        <div class="table-container">
          <div class="table-container__center">
            <TemplateSectionHeaderRows :section="this.section"/>
            <TemplateSectionPlaceholder
              v-if="showPlaceHolder"
              :section="this.section"
            />
            <div v-if="showGrid">
              <slot
                :section="section"
                name="table-container__content"
                @toggle-editing-settings="toggleEditingSettings"
              ></slot>
            </div>

            <div v-if="section.id === 'section_fixedassets'">
              <div class="SectionTable">
                <TemplateSectionResourceTableRow emptyRow/>
                <TemplateSectionResourceTableRow emptyRow/>
              </div>
              <TemplateSectionCenterResourceGroup
                :section="getSectionById('section_depreciation')"
                :showResourceSelector="true"
              />
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import TemplateSectionHeaderRows
  from '@/components/sections/TemplateSection/TemplateSectionHeaderRows';
import TemplateSectionPlaceholder
  from '@/components/sections/TemplateSection/TemplateSectionPlaceholder';
import TemplateSectionCenterResourceGroup
  from '@/components/sections/TemplateSection/TemplateSectionCenterResourceGroup';
import TemplateSectionResourceTableRow
  from '@/components/sections/TemplateSection/TemplateSectionResourceTableRow';
import Mixin from '../../mixins/mixin';

export default {
  components: {
    TemplateSectionResourceTableRow,
    TemplateSectionCenterResourceGroup,
    TemplateSectionPlaceholder,
    TemplateSectionHeaderRows,
  },
  mixins: [Mixin],
  props: {
    isScrolled: Boolean,
    section: Object,
    editResource: Function,
    quickAddResources: Function,
  },
  data: () => ({
    showHelp: false,
    scrollToNext: false,
    dialogResourceQuickSelectVisible: false,
    selectedResourceIndexes: [],
    selectedGroup: null,
    searchString: '',
    selectedResources: [],
    dialogAssumptions: [],
    dialogConfig: {},
  }),
  computed: {
    showPlaceHolder() {
      const sect = this.getSectionById(this.section.id);
      return sect.sectionResources && sect.sectionResources.length === 0;
    },
    showGrid() {
      const sect = this.getSectionById(this.section.id);
      const isResourceSection = sect.sectionResources;
      return (isResourceSection && sect.sectionResources.length > 0) || !isResourceSection;
    },
    rows() {
      const rows = [];
      rows.push({
      }, {
        className: 'row-section-header',
        content: this.section.title,
        units: 'ui_assumptions_columns__units',
        zeroPeriod: '"0"',
      });

      return rows;
    },
  },
  methods: {
    toggleEditingSettings() {
      this.section.isEditingSettings = !this.section.isEditingSettings;
    },
    saveResource(dCfg) {
      const path = 'activeTemplate.data.divisions[0]';

      // eslint-disable-next-line
      const { sectionResources } = _.get(this.$store.state, path);

      // eslint-disable-next-line
      const exists = sectionResources.find((resource) => {
        return resource.id === dCfg.resource.id;
      });

      if (exists) {
        // existing
        // eslint-disable-next-line
        const sectionResourceIndex = sectionResources.findIndex((sr) => sr.id === dCfg.resource.id);

        sectionResources.splice(sectionResourceIndex, 1, dCfg.resource);

        // update coreResource name
        const { coreResources } = this.$store.state.activeTemplate.data;
        const coreResource = coreResources.find((cr) => cr.id
          === dCfg.resource.coreResource.id);
        coreResource.name = dCfg.resource.coreResource.name;
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });
      } else {
        // new
        // save new coreResource
        const { coreResources } = this.$store.state.activeTemplate.data;
        coreResources.push(dCfg.resource.coreResource);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.coreResources',
          value: coreResources,
        });

        // if property tax, add lookupId to the parent resource
        const isBigResourceDialogVisible = this.$store.state.dialogs.editResourceDialogVisible;
        if (isBigResourceDialogVisible) {
          // eslint-disable-next-line
          this.dialogConfig.resource.otherAssumptions.taxproperty.lookupId = dCfg.resource.id;
        }

        sectionResources.push(dCfg.resource);
      }

      this.$store.commit('updateState', {
        path: `${path}.sectionResources`,
        value: sectionResources,
      });
    },
    onSave(keepDialogOpen) {
      const selectedSuggested = this.tab === 0;
      const dCfg = this.dialogConfig;
      const dialogStorePath = 'dialogs.editResourceDialogSimpleVisible';

      if (selectedSuggested) {
        for (let i = 0; i < this.selectedResources.length; i++) {
          const { formula } = this.selectedResources[i];
          if (formula) {
            // check if the formula is already there in formulas
            const formulaExists = this.$store.state.activeTemplate.data.formulas.find((f) => f.id === formula.id);
            if (!formulaExists) {
              const { language } = this.$store.state.activeTemplate;
              formula.name = formula.name[language];
              formula.variables.forEach((variable) => {
                // eslint-disable-next-line
                variable.name = variable.name[language];
                if (typeof variable.units === 'object') {
                  // eslint-disable-next-line
                  variable.units = variable.units[language];
                }
                return variable;
              });
              // save formula in the template formulas
              const { formulas } = this.$store.state.activeTemplate.data;
              formulas.push(formula);
              this.$store.commit('updateState', {
                path: 'activeTemplate.data.formulas',
                value: formulas,
              });
            }
          }

          for (let j = 0; j < this.selectedResources[i].count; j++) {
            // eslint-disable-next-line
            const sectionResource = this.createNewSectionResource(this.section, this.selectedResources[i].rel, formula && formula.id);
            const suffix = j >= 1 ? ` ${j + 1}` : '';
            sectionResource.coreResource.name = `${this.selectedResources[i].name}${suffix}`;
            // save new coreResource
            const { coreResources } = this.$store.state.activeTemplate.data;
            coreResources.push(sectionResource.coreResource);
            this.$store.commit('updateState', {
              path: 'activeTemplate.data.coreResources',
              value: coreResources,
            });

            // TODO - need this?
            // const { sectionResources } = this.$store.state.activeTemplate.data.divisions[0];
            // sectionResources.push(sectionResource);
            // this.$store.commit('updateState', {
            //   path: 'activeTemplate.data.sectionResources',
            //   value: sectionResources,
            // });
          }
        }
        // empty selections
        this.selectedResources = [];
      } else {
        this.saveResource(dCfg);
      }
      dCfg.resource = null;
      if (!keepDialogOpen) {
        this.$store.commit('updateState', {
          path: dialogStorePath,
          value: false,
        });
        this.section.isEditingSettings = false;
      }
    },
  },
  mounted() {
    if (this.section.suggestedResources && !this.section.suggestedResources.length) {
      const searchString = this.$store.state.activeTemplate.searchString || this.$store.state.activeTemplate.name || 'Cafe';
      setTimeout(() => {
        console.log(this.section.id);
        this.$store.dispatch('getOpenAI', {
          searchString,
          sectionId: this.section.id,
        });
      }, 2000);
    }
  },
  updated() {},
};
</script>
